import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Sparkles, Clock } from 'lucide-react';

export function PromoBanner() {
  const [b, setB] = useState(null);
  useEffect(() => { api.get('/promo-banner').then(r => setB(r.data)).catch(() => {}); }, []);
  if (!b || !b.enabled) return null;
  const color = b.color || '#65A30D';
  return (
    <div data-testid="promo-banner" className="rounded-2xl p-4 relative overflow-hidden mb-5"
         style={{ border: `1px solid ${color}66`, background: `${color}12` }}>
      <div className="absolute -right-6 -top-8 w-28 h-28 rounded-full blur-2xl" style={{ background: `${color}33` }} />
      <div className="relative flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: `${color}22` }}>
          <Sparkles className="w-5 h-5" style={{ color }} />
        </div>
        <div className="min-w-0 flex-1">
          {b.badge && <span className="text-[10px] font-black tracking-widest" style={{ color }}>{b.badge}</span>}
          <div className="font-display font-black text-lg leading-tight">{b.title}</div>
          {b.subtitle && <div className="text-xs text-foreground/70">{b.subtitle}</div>}
        </div>
        {b.ends_text && <span className="text-[11px] font-semibold inline-flex items-center gap-1 flex-shrink-0" style={{ color }}><Clock className="w-3.5 h-3.5" /> {b.ends_text}</span>}
      </div>
    </div>
  );
}
